import { Button } from '@noorden-insurtech/alba-design-system';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { FileBadge, FileText, Handshake } from 'lucide-react';

export const Route = createFileRoute('/_app/dashboard')({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <div className='relative flex min-h-full flex-col gap-6 p-6 lg:p-10'>
      <div className='aspect-[3/1] lg:aspect-[17/3] w-full overflow-hidden rounded-3xl bg-[#2C2864]'>
        <img
          src='/banner-portal-assessorias.png'
          alt='Banner Portal Assessorias'
          className='h-full w-full object-cover object-[60%_50%] lg:object-contain'
        />
      </div>

      <div className='flex flex-col lg:flex-row lg:items-stretch gap-4'>
        <div className='flex flex-col gap-4 lg:justify-between lg:flex-1 lg:min-w-0'>
          <Button
            variant='secondary'
            size='large'
            className='w-full h-14 lg:h-20 rounded-2xl gap-2 lg:gap-3 justify-center bg-[#129440] hover:bg-[#0f7a34] active:bg-[#0f7a34] border-[#129440] text-white [&>svg]:text-white [&>span]:text-white'
            onClick={() => navigate({ to: '/quotes' })}
          >
            <Handshake className='h-6 w-6 lg:h-10 lg:w-10' strokeWidth={2} />
            <span
              className='font-bold text-xl lg:text-3xl text-white'
              style={{ fontFamily: 'Gotham Bold, sans-serif' }}
            >
              Cotações
            </span>
          </Button>

          <Button
            variant='secondary'
            size='large'
            className='w-full h-14 lg:h-20 rounded-2xl gap-2 lg:gap-3 justify-center bg-[#129440] hover:bg-[#0f7a34] active:bg-[#0f7a34] border-[#129440] text-white [&>svg]:text-white [&>span]:text-white'
            onClick={() => navigate({ to: '/proposals' })}
          >
            <FileText className='h-6 w-6 lg:h-10 lg:w-10' strokeWidth={2} />
            <span
              className='font-bold text-xl lg:text-3xl text-white'
              style={{ fontFamily: 'Gotham Bold, sans-serif' }}
            >
              Propostas
            </span>
          </Button>

          <Button
            variant='secondary'
            size='large'
            className='w-full h-14 lg:h-20 rounded-2xl gap-2 lg:gap-3 justify-center bg-[#129440] hover:bg-[#0f7a34] active:bg-[#0f7a34] border-[#129440] text-white [&>svg]:text-white [&>span]:text-white'
            onClick={() => navigate({ to: '/policies' })}
          >
            <FileBadge className='h-6 w-6 lg:h-10 lg:w-10' strokeWidth={2} />
            <span
              className='font-bold text-xl lg:text-3xl text-white'
              style={{ fontFamily: 'Gotham Bold, sans-serif' }}
            >
              Apólices
            </span>
          </Button>
        </div>

        <div className='aspect-[83/20] w-full lg:flex-[1.7] lg:min-w-0 overflow-hidden rounded-3xl border-2 border-[#2C2864] bg-white'>
          <img
            src='/banner-campanha-comissao.png'
            alt='Potencialize suas vendas com a Alba'
            className='h-full w-full object-contain object-center'
          />
        </div>
      </div>
    </div>
  );
}
